import { useCallback, useState } from 'react';

/** Shared state for dialogs and navigation panels. */
export function useDisclosure(initiallyOpened = false) {
    const [opened, setOpened] = useState(initiallyOpened);
    const open = useCallback(() => setOpened(true), []);
    const close = useCallback(() => setOpened(false), []);
    const toggle = useCallback(() => setOpened((value) => !value), []);
    return { opened, open, close, toggle };
}
